import { render, staticRenderFns } from "./LiveStreamAndBibleCloudLayout.vue?vue&type=template&id=1a244cd4&scoped=true&"
import script from "./LiveStreamAndBibleCloudLayout.vue?vue&type=script&lang=js&"
export * from "./LiveStreamAndBibleCloudLayout.vue?vue&type=script&lang=js&"
import style0 from "./LiveStreamAndBibleCloudLayout.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LiveStreamAndBibleCloudLayout.vue?vue&type=style&index=1&id=1a244cd4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a244cd4",
  null
  
)

export default component.exports